<div class="error-container">
  @switch (reason) {
    @case ('contract') {
      <h1 class="error-code error-code--text" i18n="@@pages.unauthorized.title.contractExpired">契約終了</h1>
      @if (sectionName) {
        <p class="error-detail">
          <strong>{{ sectionName }}</strong>
        </p>
      }
      <p class="error-message" i18n="@@pages.unauthorized.message.contractExpired">
        このセクションの契約が終了しているため、アクセスできません。
      </p>
      <p class="error-contact" i18n="@@pages.unauthorized.message.contactForRenewal">
        ご利用を継続される場合は、管理者にお問い合わせください。
      </p>
    }
    @case ('feature') {
      <h1 class="error-code" i18n="@@pages.unauthorized.title.main">403</h1>
      <h2 class="error-title" i18n="@@pages.unauthorized.title.featureUnavailable">機能が利用できません</h2>
      <p class="error-message" i18n="@@pages.unauthorized.message.featureUnavailable">
        この機能はご契約に含まれていません。
      </p>
      @if (hasFeatureInOtherGroup) {
        <p class="error-hint" i18n="@@pages.unauthorized.hint.otherGroup">
          他のセクショングループでは利用可能な場合があります。
        </p>
      }
      <p class="error-contact" i18n="@@pages.unauthorized.message.contactAdmin">
        ご利用をご希望の場合は、管理者にお問い合わせください。
      </p>
    }
    @case ('role') {
      <h1 class="error-code" i18n="@@pages.unauthorized.title.main">403</h1>
      <h2 class="error-title" i18n="@@pages.unauthorized.title.noPermission">アクセス権限がありません</h2>
      <p class="error-message" i18n="@@pages.unauthorized.message.noPermission">
        このページを表示する権限がありません。
      </p>
    }
    @default {
      <h1 class="error-code" i18n="@@pages.unauthorized.title.main">403</h1>
      <h2 class="error-title" i18n="@@pages.unauthorized.title.noPermission">アクセス権限がありません</h2>
      <p class="error-message" i18n="@@pages.unauthorized.message.noPermission">
        このページを表示する権限がありません。
      </p>
    }
  }

  <div class="actions">
    @if (reason === 'contract') {
      @if (hasActiveSection) {
        <a [routerLink]="switchSectionLink" class="button button--primary" i18n="@@pages.unauthorized.button.switchSection">
          別のセクションに切り替える
        </a>
      }
      <a [routerLink]="loginLink" class="button" i18n="@@pages.unauthorized.button.backToLogin">
        ログイン画面に戻る
      </a>
    } @else {
      <a [routerLink]="backLink" class="button button--primary" i18n="@@pages.unauthorized.button.backToHome">
        ホームに戻る
      </a>
      <a [routerLink]="loginLink" class="button" i18n="@@pages.unauthorized.button.backToLogin">
        ログイン画面に戻る
      </a>
    }
  </div>
</div>
